module.exports = "<div class=\"wrapper\">\n    <div class=\"wrapper-left\">\n        <app-sidebar></app-sidebar>\n    </div>\n    <div class=\"content-fluid\">\n        <app-navbar></app-navbar>\n        <br>\n        <div class=\"content\">\n            <router-outlet></router-outlet>\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard/dashboard.component.html
// module id = ./src/app/components/dashboard/dashboard.component.html
// module chunks = main